import { createQuery } from '@/queries'
import { getUserProfileData } from '@/features/profile/api/profile-data'
import type { AxiosResponse } from 'axios'
import type { MaybeRef } from 'vue'
import type { UserProfileDataResponse } from '@/types/profile-data'

type UserProfileDataQueryResponse = Awaited<ReturnType<typeof getUserProfileData>> extends AxiosResponse<infer T>
    ? T
    : never

export const useUserProfileDataQuery = (enabled: MaybeRef<boolean> = true) => {
    return createQuery<UserProfileDataQueryResponse>({
        key: ['user-profile', 'profile-data'],
        fetcher: async () => {
            const response = await getUserProfileData()
            return response.data
        },
        enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
    })
}
